exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkout-header-breadcrumbs{color:#545454;font-size:.875rem;padding:1rem 0;border-bottom:2px solid #eee}@media (min-width:768px){.checkout-header-breadcrumbs{font-size:1.125rem}}.checkout-header-breadcrumb{margin-right:1.5rem}@media (min-width:768px){.checkout-header-breadcrumb{margin-right:2.5rem}}.checkout-header-breadcrumb-active{color:#212120;font-weight:500}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/SignupHeader/SignupHeader.scss
 ** module id = 1217
 ** module chunks = 0
 **/